<h2 class="text-xl font-medium text-neutral-800">
  <ng-content></ng-content>
</h2>
